import { contextMenuManager } from './ContextMenuManager.js';

/**
 * Context menu for right-click actions
 */
export class ContextMenu {
    constructor() {
        this.menu = null;
        this.isVisible = false;
        this.onRename = null;
        this.onDelete = null;
        this.createElement();
    }

    /**
     * Create the context menu DOM element
     */
    createElement() {
        this.menu = document.createElement('div');
        this.menu.id = 'context-menu';
        this.menu.className = 'fixed bg-slate-800 border border-slate-700 rounded-lg shadow-2xl py-2 z-[1002] hidden min-w-[180px]';

        // Create menu items
        const renameItem = this.createMenuItem(
            'Renommer',
            '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/></svg>',
            () => this.handleRename()
        );

        const deleteItem = this.createMenuItem(
            'Supprimer',
            '<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/></svg>',
            () => this.handleDelete(),
            'text-red-400 hover:bg-red-600/20'
        );

        this.menu.appendChild(renameItem);
        this.menu.appendChild(deleteItem);

        document.body.appendChild(this.menu);

        // Close menu when clicking outside
        document.addEventListener('click', (e) => {
            if (this.isVisible && !this.menu.contains(e.target)) {
                this.hide();
            }
        });

        console.log('✅ Context menu created');
    }

    /**
     * Create a menu item
     */
    createMenuItem(label, icon, onClick, extraClasses = '') {
        const item = document.createElement('div');
        item.className = `px-4 py-2 hover:bg-slate-700 cursor-pointer flex items-center gap-3 text-sm text-slate-200 transition-colors ${extraClasses}`;

        item.innerHTML = `
            ${icon}
            <span>${label}</span>
        `;

        item.addEventListener('click', (e) => {
            e.stopPropagation();
            onClick();
            this.hide();
        });

        return item;
    }

    /**
     * Show the context menu at specific position
     */
    show(x, y, onRename, onDelete) {
        // Notify the manager that this menu is now active (will close other menus)
        contextMenuManager.setActiveMenu(this);

        this.onRename = onRename;
        this.onDelete = onDelete;

        // Position the menu
        this.menu.style.left = `${x}px`;
        this.menu.style.top = `${y}px`;

        // Make sure menu stays within viewport
        const rect = this.menu.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        if (rect.right > viewportWidth) {
            this.menu.style.left = `${viewportWidth - rect.width - 10}px`;
        }

        if (rect.bottom > viewportHeight) {
            this.menu.style.top = `${viewportHeight - rect.height - 10}px`;
        }

        this.menu.classList.remove('hidden');
        this.isVisible = true;
        console.log('📋 Context menu shown');
    }

    /**
     * Hide the context menu
     */
    hide() {
        this.menu.classList.add('hidden');
        this.isVisible = false;
        this.onRename = null;
        this.onDelete = null;

        // Clear from manager if this was the active menu
        if (contextMenuManager.activeMenu === this) {
            contextMenuManager.clearActiveMenu();
        }

        console.log('📋 Context menu hidden');
    }

    /**
     * Handle rename action
     */
    handleRename() {
        if (this.onRename) {
            this.onRename();
        }
    }

    /**
     * Handle delete action
     */
    handleDelete() {
        if (this.onDelete) {
            this.onDelete();
        }
    }

    /**
     * Remove the menu from DOM
     */
    dispose() {
        if (this.menu && this.menu.parentNode) {
            this.menu.parentNode.removeChild(this.menu);
            this.menu = null;
            console.log('✅ Context menu disposed');
        }
    }
}
